// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contractor-container {
  /* text-align: center; */
  padding: 20px;
}
.contractor_search {
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 5px 10px;
  width: 100%;
  width: 350px;
  border-radius: 50px;
  box-shadow: 2px 0 15px #04847e48;
  height: 45px;
}
.contractorview-btn {
  background: #007bff;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;
}
.add_contractor_button_wrapper {
  margin: 20px;
}

.add_contractor_button_wrapper button {
  padding: 15px 23px;
  font-size: 16px;
  cursor: pointer;
  background-color: #e02c2c;
  color: whitesmoke;
  border: none;
  border-radius: 50px;
  font-weight: 600;
}
.add_payment_button {
  padding: 10px 15px;
  font-size: 16px;
  cursor: pointer;
  background-color: #0dada5;
  color: whitesmoke;
  border: none;
  border-radius: 5px;
}
.contractor_delete_button {
  margin-left: 5px;
  padding: 10px 15px;
  font-size: 16px;
  cursor: pointer;
  background-color: orangered;
  color: whitesmoke;
  border: none;
  border-radius: 5px;
}

.contractor_form_modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.contractor_form_modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  position: relative;
}

.contractor_form_close {
  position: absolute;
  top: 10px;
  right: 15px;
  font-size: 24px;
  cursor: pointer;
}

.contractor_form {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.contractor_form label {
  text-align: left;
  font-weight: bold;
}

.contractor_form input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.contractor_form_submit_button {
  background: #007bff;
  color: white;
  padding: 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.contractor_form_submit_button:hover {
  background: #0056b3;
}

@media (max-width: 768px) {
  .contractor_form_modal-content {
    width: 95%;
  }
}

/* contractor table */
.contractor_table_container {
  width: 100%;
  /* padding: 20px; */
  background: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  overflow-x: auto;
}

.contractor_table_heading {
  text-align: center;
  color: #333;
  margin-bottom: 15px;
}

.contractor_table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  overflow: hidden;
}

.contractor_table thead {
  background: #007bff;
  color: white;
}

.contractor_table th,
.contractor_table td {
  padding: 12px;
  text-align: left;
  border: 1px solid #ddd;
}

.contractor_table tbody tr:nth-child(even) {
  background: #f2f2f2;
}

.contractor_table tbody tr:hover {
  background: #e0e0e0;
}

/* Responsive Design */
@media screen and (max-width: 1024px) {
  .contractor_table th,
  .contractor_table td {
    padding: 10px;
    font-size: 14px;
  }
}

@media screen and (max-width: 768px) {
  .contractor_table_container {
    padding: 10px;
  }

  .contractor_table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }
}

@media screen and (max-width: 480px) {
  .contractor_table th,
  .contractor_table td {
    padding: 8px;
    font-size: 12px;
  }
}
/* contractor card */
.contractor-container {
  padding: 20px;
}

/* Heading */
.contractor-heading {
  text-align: center;
  font-size: 28px;
  font-weight: bold;
  color: #333;
}

/* Table Styling */
.contractor_table_container {
  margin-top: 20px;
  background: #fff;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.table-responsive {
  overflow-x: auto;
}

.contractor_table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.contractor_table th,
.contractor_table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.contractor_table th {
  background: #007bff;
  color: white;
}

.contractor_table tr:nth-child(even) {
  background: #f9f9f9;
}

/* Button */
.view-btn {
  background: #28a745;
  color: white;
  padding: 6px 12px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;
}

.view-btn:hover {
  background: #218838;
}

/* Popup */
.contractor_popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  animation: fadeIn 0.3s ease-in-out;
}

.contractor_popup_content {
  background: rgba(255, 255, 255, 0.9);
  padding: 20px;
  /* width: 600px; */
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  animation: popUp 0.3s ease-in-out;
  line-height: 35px;
  overflow: auto;
  height: 550px;
  scrollbar-width: none;
}
.constractorview-btn {
  background: #007bff;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;
}

.contractor_popup_close {
  font-size: 40px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000000;
  border-radius: 50px;
  margin-left: 519px;
}

.installment_table_wrapper {
  margin-top: 10px;
  overflow: auto;
}

.installment_table {
  width: 100%;
  border-collapse: collapse;
}

.installment_table th,
.installment_table td {
  padding: 10px;
  border: 1px solid #ddd;
}

.installment_table th {
  background: #007bff;
  color: white;
}

.no-data {
  text-align: center;
  padding: 10px;
}

/* Responsive */
@media screen and (max-width: 768px) {
  .contractor_popup_content {
    width: 90%;
  }
}

/* contractor payment form */
.contractor_form_wrapper {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 1);
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 400px;
  z-index: 1000;
}

.contractor_payment_form {
  display: flex;
  flex-direction: column;
  gap: 15px;
  position: relative;
}
.contractor_payment_close_button {
  position: absolute;
  top: -52px;
  right: -20px;
  background: red;
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  font-size: 16px;
  border-radius: 50%;
}

.contractor_payment_close_button:hover {
  background: darkred;
}

.contractor_payment_form input,
.contractor_payment_form select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
}

.contractor_payment_submit_button {
  background: #28a745;
  color: white;
  padding: 10px;
  font-size: 16px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.contractor_payment_submit_button:hover {
  background: #218838;
}

/* Background overlay */
.contractor_form_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

@media (max-width: 480px) {
  .contractor_form_wrapper {
    width: 95%;
    padding: 15px;
  }
  .contractor-container {
    /* text-align: center; */
    padding: 0px;
  }
  .contractor_popup_close {
    margin-left: 233px;
  }
}
.add_contractor_button_wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 120px;
  flex-wrap: wrap;
}

.paymentTableEditForm {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 400px;
  z-index: 1000;
}

.paymentTableEditForm button {
  border: none;
  background: none;
  font-size: 16px;
  cursor: pointer;
}

.paymentTableEditForm .paymentTableEditForm_submit {
  /* position: absolute; */
  top: 10px;
  right: 15px;
  font-weight: bold;
  color: #ffffff;
  background-color: #007bff;
}

.paymentTableEditForm_input,
.paymentTableEditForm_select {
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
}

.paymentTableEditForm_submit {
  width: 100%;
  padding: 12px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
}

.paymentTableEditForm_submit:hover {
  background: #0056b3;
}

.paymentTableEditForm_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

@media (max-width: 768px) {
  .paymentTableEditForm {
    width: 95%;
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .paymentTableEditForm {
    width: 90%;
    padding: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/contractor/contractordetail.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;EAC3B,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;;IAEE,aAAa;IACb,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE;;IAEE,YAAY;IACZ,eAAe;EACjB;AACF;AACA,oBAAoB;AACpB;EACE,aAAa;AACf;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,iCAAiC;EACjC,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA,eAAe;AACf;EACE;IACE,UAAU;EACZ;AACF;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,UAAU;EACV,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,wBAAwB;IACxB,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,UAAU;EACV,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;AACF;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;AACF","sourcesContent":[".contractor-container {\n  /* text-align: center; */\n  padding: 20px;\n}\n.contractor_search {\n  background-color: #ffffff;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  padding: 5px 10px;\n  width: 100%;\n  width: 350px;\n  border-radius: 50px;\n  box-shadow: 2px 0 15px #04847e48;\n  height: 45px;\n}\n.contractorview-btn {\n  background: #007bff;\n  color: white;\n  padding: 10px 15px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: 0.3s;\n}\n.add_contractor_button_wrapper {\n  margin: 20px;\n}\n\n.add_contractor_button_wrapper button {\n  padding: 15px 23px;\n  font-size: 16px;\n  cursor: pointer;\n  background-color: #e02c2c;\n  color: whitesmoke;\n  border: none;\n  border-radius: 50px;\n  font-weight: 600;\n}\n.add_payment_button {\n  padding: 10px 15px;\n  font-size: 16px;\n  cursor: pointer;\n  background-color: #0dada5;\n  color: whitesmoke;\n  border: none;\n  border-radius: 5px;\n}\n.contractor_delete_button {\n  margin-left: 5px;\n  padding: 10px 15px;\n  font-size: 16px;\n  cursor: pointer;\n  background-color: orangered;\n  color: whitesmoke;\n  border: none;\n  border-radius: 5px;\n}\n\n.contractor_form_modal {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n}\n\n.contractor_form_modal-content {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  width: 90%;\n  max-width: 500px;\n  position: relative;\n}\n\n.contractor_form_close {\n  position: absolute;\n  top: 10px;\n  right: 15px;\n  font-size: 24px;\n  cursor: pointer;\n}\n\n.contractor_form {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.contractor_form label {\n  text-align: left;\n  font-weight: bold;\n}\n\n.contractor_form input {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.contractor_form_submit_button {\n  background: #007bff;\n  color: white;\n  padding: 10px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.contractor_form_submit_button:hover {\n  background: #0056b3;\n}\n\n@media (max-width: 768px) {\n  .contractor_form_modal-content {\n    width: 95%;\n  }\n}\n\n/* contractor table */\n.contractor_table_container {\n  width: 100%;\n  /* padding: 20px; */\n  background: #f9f9f9;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  overflow-x: auto;\n}\n\n.contractor_table_heading {\n  text-align: center;\n  color: #333;\n  margin-bottom: 15px;\n}\n\n.contractor_table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.contractor_table thead {\n  background: #007bff;\n  color: white;\n}\n\n.contractor_table th,\n.contractor_table td {\n  padding: 12px;\n  text-align: left;\n  border: 1px solid #ddd;\n}\n\n.contractor_table tbody tr:nth-child(even) {\n  background: #f2f2f2;\n}\n\n.contractor_table tbody tr:hover {\n  background: #e0e0e0;\n}\n\n/* Responsive Design */\n@media screen and (max-width: 1024px) {\n  .contractor_table th,\n  .contractor_table td {\n    padding: 10px;\n    font-size: 14px;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .contractor_table_container {\n    padding: 10px;\n  }\n\n  .contractor_table {\n    display: block;\n    overflow-x: auto;\n    white-space: nowrap;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .contractor_table th,\n  .contractor_table td {\n    padding: 8px;\n    font-size: 12px;\n  }\n}\n/* contractor card */\n.contractor-container {\n  padding: 20px;\n}\n\n/* Heading */\n.contractor-heading {\n  text-align: center;\n  font-size: 28px;\n  font-weight: bold;\n  color: #333;\n}\n\n/* Table Styling */\n.contractor_table_container {\n  margin-top: 20px;\n  background: #fff;\n  border-radius: 10px;\n  padding: 15px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.table-responsive {\n  overflow-x: auto;\n}\n\n.contractor_table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 10px;\n}\n\n.contractor_table th,\n.contractor_table td {\n  padding: 12px;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n}\n\n.contractor_table th {\n  background: #007bff;\n  color: white;\n}\n\n.contractor_table tr:nth-child(even) {\n  background: #f9f9f9;\n}\n\n/* Button */\n.view-btn {\n  background: #28a745;\n  color: white;\n  padding: 6px 12px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: 0.3s;\n}\n\n.view-btn:hover {\n  background: #218838;\n}\n\n/* Popup */\n.contractor_popup {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n.contractor_popup_content {\n  background: rgba(255, 255, 255, 0.9);\n  padding: 20px;\n  /* width: 600px; */\n  border-radius: 12px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n  animation: popUp 0.3s ease-in-out;\n  line-height: 35px;\n  overflow: auto;\n  height: 550px;\n  scrollbar-width: none;\n}\n.constractorview-btn {\n  background: #007bff;\n  color: white;\n  padding: 10px 15px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: 0.3s;\n}\n\n.contractor_popup_close {\n  font-size: 40px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #000000;\n  border-radius: 50px;\n  margin-left: 519px;\n}\n\n.installment_table_wrapper {\n  margin-top: 10px;\n  overflow: auto;\n}\n\n.installment_table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.installment_table th,\n.installment_table td {\n  padding: 10px;\n  border: 1px solid #ddd;\n}\n\n.installment_table th {\n  background: #007bff;\n  color: white;\n}\n\n.no-data {\n  text-align: center;\n  padding: 10px;\n}\n\n/* Responsive */\n@media screen and (max-width: 768px) {\n  .contractor_popup_content {\n    width: 90%;\n  }\n}\n\n/* contractor payment form */\n.contractor_form_wrapper {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: rgba(255, 255, 255, 1);\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n  width: 90%;\n  max-width: 400px;\n  z-index: 1000;\n}\n\n.contractor_payment_form {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  position: relative;\n}\n.contractor_payment_close_button {\n  position: absolute;\n  top: -52px;\n  right: -20px;\n  background: red;\n  color: white;\n  border: none;\n  padding: 5px 10px;\n  cursor: pointer;\n  font-size: 16px;\n  border-radius: 50%;\n}\n\n.contractor_payment_close_button:hover {\n  background: darkred;\n}\n\n.contractor_payment_form input,\n.contractor_payment_form select {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n}\n\n.contractor_payment_submit_button {\n  background: #28a745;\n  color: white;\n  padding: 10px;\n  font-size: 16px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.contractor_payment_submit_button:hover {\n  background: #218838;\n}\n\n/* Background overlay */\n.contractor_form_overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n}\n\n@media (max-width: 480px) {\n  .contractor_form_wrapper {\n    width: 95%;\n    padding: 15px;\n  }\n  .contractor-container {\n    /* text-align: center; */\n    padding: 0px;\n  }\n  .contractor_popup_close {\n    margin-left: 233px;\n  }\n}\n.add_contractor_button_wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 120px;\n  flex-wrap: wrap;\n}\n\n.paymentTableEditForm {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: white;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);\n  width: 90%;\n  max-width: 400px;\n  z-index: 1000;\n}\n\n.paymentTableEditForm button {\n  border: none;\n  background: none;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.paymentTableEditForm .paymentTableEditForm_submit {\n  /* position: absolute; */\n  top: 10px;\n  right: 15px;\n  font-weight: bold;\n  color: #ffffff;\n  background-color: #007bff;\n}\n\n.paymentTableEditForm_input,\n.paymentTableEditForm_select {\n  width: 100%;\n  padding: 10px;\n  margin: 10px 0;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n}\n\n.paymentTableEditForm_submit {\n  width: 100%;\n  padding: 12px;\n  background: #007bff;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.paymentTableEditForm_submit:hover {\n  background: #0056b3;\n}\n\n.paymentTableEditForm_overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n}\n\n@media (max-width: 768px) {\n  .paymentTableEditForm {\n    width: 95%;\n    padding: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .paymentTableEditForm {\n    width: 90%;\n    padding: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
